import type { SignInController } from "../SignInController";
import type { SignInProfileFillingStepController } from "./SignInProfileFillingStepController";
import { useAuthSDK } from "~/features/auth-sdk";
import { useUserStore } from "~/features/store/user";
import type { IUserMM } from "~/entities/user/models/IUserMM";

export function useSignInFillingProfileStep(signInController: SignInController, fillingProfileStepController: SignInProfileFillingStepController, unblockFillingProfileStepPopup: () => void) {
  const isFillingProfileStep = computed(() => signInController.isFillingProfileStep);
  const goToFillingProfileStep = signInController.goToFillingProfileStep.bind(signInController);

  const formData = fillingProfileStepController.formData;
  const hasChanges = computed(() => fillingProfileStepController.form.hasChanges());
  const isLoading = fillingProfileStepController.isLoading;

  const { registerProfile, setNotifications } = useUserStore();
  const { magnitIdCode, login } = useAuthSDK();

  async function handleSubmit() {
    const isValid = fillingProfileStepController.form.validate();
    if (!isValid) return;

    try {
      isLoading.value = true;

      const user: IUserMM = {
        firstName: formData.name.value || '',
        birthDate: formData.birthDate.value || '',
        email: formData.email.value || '',
      }

      const { userId } = await registerProfile(user, magnitIdCode.value);
      await login({ magnitIDCode: magnitIdCode.value, userId });
      if (formData.notifications.value) {
        await setNotifications();
      }

      unblockFillingProfileStepPopup();

      signInController.closeSignInPopup();
      signInController.resetStep();
    } catch (error) {
      handleError(error);
    } finally {
      isLoading.value = false;
    }
  }

  function handleError(error: unknown) {
    console.error(error);
  }

  return {
    isFillingProfileStep,
    goToFillingProfileStep,
    formData,
    hasChanges,
    isLoading,
    handleSubmit,
  }
}